<template>
  <dx-navbar-aside :hidden="hidden">
    <dx-async :method="loadCategories">
      <div v-if="!hidden">
        <div class="header">
          <dx-heading color="blue">Olá, {{ this.firstName }}!</dx-heading>
        </div>
        <dx-navbar-aside-item
          align="left"
          :description="`Meus processos (${categoriesCounter.myLicenses})`"
          redirect-page="RegulatorHome"
          :action="() => setRegulatorLicensesFilter('')"
        />
        <dx-navbar-aside-item
          align="left"
          :description="`Todos os processos (${categoriesCounter.allLicenses})`"
          redirect-page="RegulatorAllProcesses"
          :action="() => setRegulatorLicensesFilter('')"
        />
        <dx-navbar-aside-item
          align="left"
          :description="`Deferidos (${categoriesCounter.deferredLicenses})`"
          redirect-page="RefulatorDeferred"
          :action="() => setRegulatorLicensesFilter('')"
        />
        <dx-navbar-aside-item
          align="left"
          :description="`Indeferidos (${categoriesCounter.rejectedLicenses})`"
          redirect-page="RefulatorRejected"
          :action="() => setRegulatorLicensesFilter('')"
        />
        <div class="header dx-margin-top--lg">
          <dx-heading size="sm">Categorias</dx-heading>
        </div>
        <dx-navbar-aside-item
          v-for="category in categories"
          :key="category.name"
          align="left"
          :description="`${category.name} (${category.counter})`"
          :action="() => setRegulatorLicensesFilter(category.name)"
          :borderColor="category.color"
        />
      </div>
      <div
        class="hide-button"
        :class="{'hidden-button': hidden}"
        @click="onClickToggleSidebar"
        @keydown="onClickToggleSidebar">
          {{ hidden ? '>' : '< Esconder' }}
      </div>
    </dx-async>
  </dx-navbar-aside>
</template>

<script>
import { getCategoryColor } from '@/services/categoriesService';
import { userService, categoriesService } from '@services';

export default {
  name: 'dx-dashboard-navbar',
  data() {
    return {
      firstName: userService.getUserDetails().name?.split(' ')[0],
      categories: [],
      categoriesCounter: {},
    };
  },

  computed: {
    hidden() {
      return this.$store.getters['sidebar/isSidebarHidden'];
    },
  },

  methods: {
    onClickToggleSidebar() {
      this.$store.dispatch('sidebar/setSidebarHidden', !this.$store.getters['sidebar/isSidebarHidden']);
    },
    setRegulatorLicensesFilter(category) {
      this.$store.dispatch('regulatorFilter/setSelectedFilter', category);
    },
    loadCategories() {
      return Promise.all([
        categoriesService.getAllCategories(),
        categoriesService.getCategoriesCounter()]).then(([categories, categoriesCounter]) => {
        this.categoriesCounter = categoriesCounter;
        this.categories = categories
          .map((category) => ({
            name: category,
            color: getCategoryColor(category),
            counter: categoriesCounter.licensesByTag[category],
          }));
      });
    },
  },
};
</script>

<style scoped lang="scss">
.header {
  text-transform: capitalize;
  text-align: center;
  margin-bottom: var(--dx-space-size--sm);
}

.hide-button {
  position: absolute;
  bottom: 0;
  background-color: white;
  border-color: black;
  padding: 10px;
  border-radius: 5px;
  width: 100%;
  color: var(--dx-color--grey);
}

.hide-button:hover {
  cursor: pointer;
  background-color: var(--dx-color--blue-light);
}

.hidden-button {
  position: absolute;
  top: 0;
  width: 32px;
}
</style>
